export default "__VITE_ASSET__5f4d75c8__"